import Api from '@/data/Api'

export default {
  download (link) {
    Api().get(
      '/' + link,
      {
        headers: {
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }
    ).then(response => {
      const blob = new Blob(
        [response.data],
        { type: 'application/pdf' }
      )
      saveFile(blob, link)
    }).catch((err) => {
      console.log(err)
    })
  }
}

function saveFile (blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    const a = document.createElement('a')
    document.body.appendChild(a)
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = filename
    a.click()
    setTimeout(() => {
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }, 0)
  }
}
